import config from './config.js'
import run from './run.js'

import CommonService from './services/CommonService.js'
import FitnessService from './services/FitnessService.js'
import UserService from './services/UserService.js'
import ArticleService from './services/ArticleService.js'

import AppCtrl from './controllers/AppCtrl.js'
import AccountCtrl from './controllers/AccountCtrl.js'
import FitnessCtrl from './controllers/FitnessCtrl.js'
import FrontCtrl from './controllers/FrontCtrl.js'
import LogCtrl from './controllers/LogCtrl.js'
import NewsCtrl from './controllers/NewsCtrl.js'
import ShowEventCtrl from './controllers/ShowEventCtrl.js'
import TodayCtrl from './controllers/TodayCtrl.js'
import UserCtrl from './controllers/UserCtrl.js'

import AspectRatio from './directives/aspectRatio.js'
import NewsInspector from './directives/newsInspector.js'
import BindHtmlCompile from './directives/bindHtmlCompile.js'
import DatePicker from './directives/wnioDatePicker.js'
import ResponsiveCalendar from './directives/responsiveCalendar.js'

const moduleName = 'wisegym.jumppakalenteri',
      moduleInject = ['ionic', 'ionic.native', 'ngSanitize', 'wisenetwork.survey', 'youtube-embed', 'toastr', 'ngIdle'];

angular
    .module(moduleName, moduleInject)
    .config(config)
    .run(run)
    .service('common', CommonService)
    .service('FitnessService', FitnessService)
    .service('UserService', UserService)
    .service('ArticleService', ArticleService)

    .controller('AppCtrl', AppCtrl)
    .controller('AccountCtrl', AccountCtrl)
    .controller('FitnessCtrl', FitnessCtrl)
    .controller('FrontCtrl', FrontCtrl)
    .controller('LogCtrl', LogCtrl)
    .controller('NewsCtrl', NewsCtrl)
    .controller('ShowEventCtrl', ShowEventCtrl)
    .controller('TodayCtrl', TodayCtrl)
    .controller('UserCtrl', UserCtrl)
    
    .directive('aspectRatio', AspectRatio)
    .directive('newsInspector', NewsInspector)
    .directive('responsiveCalendar', ResponsiveCalendar)
    .directive('bindHtmlCompile', BindHtmlCompile)
    .directive('wnioDatePicker', DatePicker);